import { type KPIScoreLimit, Score } from 'components/KPICard'

export const FIRST_RESPONSE_RANGE_DESCRIPTION = `Needs work = greater than 60s
    Fair = 40s - 59s
    Good = 20s - 39s
    Excellent = less than 20s
`

export const KPI_SCORES: KPIScoreLimit[] = [
  { min: 60, score: Score.NeedsWork },
  { min: 40, score: Score.Fair },
  { min: 20, score: Score.Good },
  { min: Number.MIN_VALUE, score: Score.Excellent },
]
